<template>
    <b-container fluid class="d-flex flex-column mh-100 h-100 no-gutters py-1 w-100 overflow-auto">
        <!-- Gestion des périodes -->
        <b-row class="w-100 no-gutters py-1">
            <SinglePeriod :ref="$id('singlePeriod')" :Configs.sync="configs" :Variant="Variant"
                          :Errors.sync="errorList"/>
        </b-row>

        <b-row class="w-100 no-gutters py-0 accordion">
            <DataBlockUnitCost v-for="(dataBlock, index) in dataBlocks" :key="index"
                               :Index="index + 1"
                               :DataValue.sync="dataBlocks[index]"
                               :SelectedMask="SelectedMask" :ShowOverlay.sync="showOverlay" Feature="UnitCost" :Variant="Variant"
                               :sNumeratorList="numerators" :sDenominatorList="denominators"
                               @RemoveDataBlockEvent="removeData(0)"
                               @ChangeConfigCommonWorkDataEvent="changeConfigCommonWorkData(index)"/>
        </b-row>
    </b-container>
</template>

<script lang="ts">
import {Component} from 'vue-property-decorator';
import Filters from './FeatureConfigWData/Datablock/Filters.vue';
import SinglePeriod from './Periods/SinglePeriod.vue';
import FeatureConfigWData from "@/components/commons/Config/FeatureConfigWData";
import UnitCostData from "@/types/Config/UnitCostData";
import DataBlockUnitCost from "@/components/commons/Config/FeatureConfigWData/DataBlockUnitCost.vue";
/** Traductions */
import locales from "./locales/UnitCost.json";

/**
 * Paramétrage de la fonction Coût unitaire
 * @description Hérite de FeatureConfigWData et non de FeatureConfigWData car elle ne gère pas de bloc de données
 * */
@Component({
    components: {
        DataBlockUnitCost,
        Filters,
        SinglePeriod
    },
    i18n: { messages: locales }
})
export default class UnitCost extends FeatureConfigWData<UnitCostData> {
    /** Liste des numérateurs disponibles*/
    private numerators: { Id: string, Label: string }[] = [
        {Id: "TotalTTC", Label: this.$t('CostWithTax').toString()}, // Coût TTC
        {Id: "TotalHTVA", Label: this.$t('CostWithoutTax').toString()} // Coût HTVA
    ];

    /** Liste des dénominateurs disponibles */
    private denominators: { Id: string, Label: string }[] = [
        {Id: "FinalEnergy", Label: this.$t('FinalEnergyFact').toString()}, // Energie Finale Fact
        {Id: "LowerCalorific", Label: this.$t('FinalEnergyLCV').toString()}, // Energie Finale PCI
        {Id: "Consumption", Label: this.$t('ConsumptionDelivery').toString()} // Conso / Livraison
    ];

    /** Permet de vérifier la validité des différents champs obligatoires */
    public CheckInvalidity(): boolean {
        let periodInvalid: boolean = false;

        // Vérification de l'invalidité de la période
        if(this.$id("singlePeriod") in this.$refs && this.$refs[this.$id("singlePeriod")] && typeof(this.$refs[this.$id("singlePeriod")] as any).CheckPeriodInvalidity === "function")
            periodInvalid = (this.$refs[this.$id("singlePeriod")] as any).CheckPeriodInvalidity();

        return periodInvalid;
    }

    /** Génération du titre */
    public GenerateTitle(): string {
        console.debug("UnitCost - GenerateTitle - configs", this.configs);
        // Type de synthèse
        let title: string = this.GetDataBlocksTitle();

        // Data
        title += this.numerators.find(x => x.Id == this.dataBlocks[0].Numerator).Label + " / " + this.denominators.find(x => x.Id == this.dataBlocks[0].Denominator).Label + " | ";

        if (this.$id("singlePeriod") in this.$refs && this.$refs[this.$id("singlePeriod")] && typeof (this.$refs[this.$id("singlePeriod")] as any).GeneratePeriodTitle === "function")
            title += (this.$refs[this.$id("singlePeriod")] as any).GeneratePeriodTitle();

        return title;
    }

    mounted() {
        console.debug("UnitCost - mounted - configs ", this.configs);

        // Gestion de la config
        if (this.configs && "Data" in this.configs && this.configs["Data"]) {
            this.configs.Data.Flow = "Racking";
        }

        this.init(this.configs.Data, (dataBlock) => {
            return (dataBlock.Synthesis != '');
        });
    }
}
</script>

<style scoped lang="scss">
    /** Fichier .css à importer pour toutes les fonctions d'Analysis (Evolution, Benchmarking, ...) */
    @import './analysis.scss';
</style>